import { Navigate, Outlet } from 'react-router-dom';
import type { AccessArea } from '@shared/types';
import { useAuth } from '../../hooks/useAuth';
import { IS_LOCAL_MODE } from '../../services/auth';
import { hasAccessArea } from '../../lib/access';
import { AccessDenied } from '../ui/AccessDenied';
import { PageSkeleton } from '../ui/Skeleton';

/**
 * Route-level guards used as layout routes in App.tsx:
 *   <Route element={<RequireAuth />}>
 *     <Route element={<RequireArea area="pj-kpi-management" />}> …pages… </Route>
 * Pages no longer carry their own "Access Denied" blocks.
 */

export function RequireAuth() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <PageSkeleton />;
  if (!IS_LOCAL_MODE && !isAuthenticated) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function RequireArea({ area }: { area: AccessArea }) {
  const { user } = useAuth();
  if (!hasAccessArea(user, area)) return <AccessDenied area={area} />;
  return <Outlet />;
}

export function RequireOwner() {
  const { user } = useAuth();
  if (user?.role !== 'owner') return <AccessDenied ownerOnly />;
  return <Outlet />;
}
